/**
 * Native SDK Wagmi Configuration
 * 
 * This minimal wagmi config is used in native SDK environments (Farcaster, Base, World)
 * where we DON'T want to load RainbowKit/WalletConnect which would:
 * 1. Violate the container's Content Security Policy (CSP)
 * 2. Conflict with the native SDK's wallet connection
 * 
 * The native SDKs provide their own ethereum provider (window.ethereum or sdk.wallet.ethProvider)
 * which wagmi can use directly without WalletConnect.
 */

import { createConfig, http } from 'wagmi';
import { base } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

/**
 * Minimal wagmi config for native SDK environments
 * Uses only the injected connector (window.ethereum from native SDK)
 * NO WalletConnect to avoid CSP violations
 */
export const nativeConfig = createConfig({
  chains: [base],
  connectors: [
    // Use injected connector for native SDK's ethereum provider
    injected({
      shimDisconnect: true,
    }),
  ],
  transports: {
    [base.id]: http(),
  },
  // Disable auto-connect to avoid interfering with native SDK auth
  syncConnectedChain: false,
});

